const legacyColors = {
  alabaster: '#f8f8f8',
};

/**
 * CHIMEKIT COLORS - names and labels copied
 * from https://github.com/1debit/project-otter/blob/master/src/ChimeKit/lib/colors.tsx
 */
const CKColors = {
  /**
   * Brand presence
   */
  darkGreen: '#14A961',
  brightGreen: '#2DE38E',
  /**
   * Black, greys & white
   */
  notBlack: '#333333',
  darkGrey: '#74758C',
  lightGrey: '#ECEFF1',
  white: '#FFFFFF',
  /**
   * Edge cases
   */
  alertRed: '#D91848',
  /**
   * Secondary palette
   */
  lightGreen: '#C0F7DD',
  lightBlue: '#BEDFF6',
  lightYellow: '#FFEFC8',
  lightPink: '#F2C9DF',
  chimeBlue: '#9DD0FA',
  chimeYellow: '#FFC847',
  chimePink: '#EB9BCD',
  brightBlue: '#2698E7',
  darkBlue: '#429AE6',
  darkYellow: '#E5A513',
  darkPink: '#D451A4',
  darkerGreen: '#008040',
  /**
   * System
   */
  absoluteBlack: '#000000', // Use this only in special situations, not normal design
};

/**
 * ChimeKit colors modified with transparency, converted to solid colors
 * without alpha. http://marcodiiga.github.io/rgba-to-rgb-conversion
 * For now, we'll keep these separate from CKColors until designers
 * re-organize their tint/opacity colors.
 * */
const CKTintColors = {
  notBlack: {
    a10: '#EBEBEB',
    a40: '#ADADAD',
    a60: '#858585',
    disabledOnBrightGreen: '#7BA792',
  },
  lightGrey: {
    a20: '#FBFCFC',
    a40: '#F7F9F9',
  },
  alertRed: {
    a10: '#FBE8ED',
    a40: '#F0A3B6',
  },
  darkGreen: {
    a20: '#D0EEDF',
    a40: '#A1DDC0',
    a60: '#72CBA0',
  },
  brightGreen: {
    a40: '#ABF4D2',
    a60: '#81EEBB',
  },
};

export const CKUtilityColors = {
  logoBrandColor: '#1EC677', // Doesn't meet accessibility; used only for the Chime logo
  placeholderTextColor: CKTintColors.notBlack.a60,
};

/**
 * Facade for easier migration
 */
export const colors = {
  ...legacyColors,
  ...CKColors,
  tint: CKTintColors,
  util: CKUtilityColors,
};

export default colors;
